"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectAfterMoveActionOption')(function selectAfterMoveActionOption(selection, state) {
    var optionState = state.optionState;
    optionState.nextSelection = selection;
}));
//# sourceMappingURL=selectAfterMoveActionOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-reading-pane-option/lib/actions/selectAfterMoveActionOption.js
// module id = 5116
// module chunks = 2